import { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import i18n from 'i18n';
import { CUSTOM_TABS_DIRECTION } from 'components/constants';
import CustomTabs from 'components/CustomTabs';
import i18nContext from 'components/i18n-context';
import { ROUTE_PATHS } from 'routes/constants';
import { Container } from 'uikit/Container/Container';
import './Balances.scss';

const BALANCES_TABS = [
  {
    name: 'balancesDocuments',
    title: i18n.getMessage('balances.tab.balancesDocuments'),
    icon: null,
    route: ROUTE_PATHS.BALANCES_DOCUMENTS,
    isDisabled: false
  },
  {
    name: 'currentBalances',
    title: i18n.getMessage('balances.tab.currentBalances'),
    icon: null,
    route: ROUTE_PATHS.BALANCES_CURRENT_BALANCES,
    isDisabled: true
  },
  {
    name: 'customerWalletsReport',
    title: i18n.getMessage('balances.tab.customerWalletsReport'),
    icon: null,
    route: ROUTE_PATHS.BALANCES_CUSTOMER_WALLETS_REPORT,
    isDisabled: true
  },
  {
    name: 'reports',
    title: i18n.getMessage('balances.tab.reports'),
    icon: null,
    route: ROUTE_PATHS.BALANCES_REPORTS,
    isDisabled: true
  }
];

const Balances = () => {
  const i18n = useContext(i18nContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    const path = location.pathname;

    const activeTabFromPath = BALANCES_TABS.find((tab) => tab.route === path);
    if (activeTabFromPath) {
      setActiveTab(activeTabFromPath.name);
    } else if (path === ROUTE_PATHS.BALANCES) {
      setActiveTab(BALANCES_TABS[0].name);
      navigate(BALANCES_TABS[0].route);
    }
  }, [location.pathname, navigate]);

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
    const selectedTab = BALANCES_TABS.find((tab) => tab.name === tabName);
    if (selectedTab) {
      navigate(selectedTab.route);
    }
  };

  return (
    <section className={'right-section'}>
      <Container className={'balances-container'} header={i18n.getMessage('container.balances')}>
        <div className={'balances-wrapper'}>
          <CustomTabs
            tabList={BALANCES_TABS}
            direction={CUSTOM_TABS_DIRECTION.HORIZONTAL}
            activeTab={activeTab}
            setActiveTab={handleTabChange}
          />
          <Outlet />
        </div>
      </Container>
    </section>
  );
};

export default Balances;
